<nz-layout>
  <nz-header class="section-header">
    {{'Somatometrics'|translate}}
  </nz-header>
  <nz-content>
    @for (cm of submenu; track cm) {
      @if (cm.path==componentPaths.weight) {
        <app-weight [id]="cm.path" />
      }
      @if (cm.path==componentPaths.neck) {
        <app-neck [id]="cm.path" />
      }
    }
  </nz-content>
</nz-layout>